import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';

export const useStyles = () => {
  const { theme } = useTheme();

  return useMemo(
    () => ({
      exploreButton: css`
        color: #f5f6fa;
        ${responsive.create({
          width: {
            default: '100%',
            md: 'auto',
          },
        })}
      `,
    }),
    [theme],
  );
};
